var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupBuying f16 seller-style" },
    [
      _c("div", { staticClass: "lin_15 f16 gray_3 fb" }, [
        _vm._v("拼单管理 - 详情")
      ]),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        [
          _vm.isEdit && !_vm.isEnd
            ? [
                _vm.activity.priceType === 3
                  ? _c("p", { staticClass: "ps_main_head red" }, [
                      _vm._v(
                        "温馨提示：仅支持更改拼单名称、发货地址、活动结束时间、起订量"
                      )
                    ])
                  : _c("p", { staticClass: "ps_main_head red" }, [
                      _vm._v(
                        "温馨提示：仅支持更改拼单名称、发货地址、活动结束时间、活动库存"
                      )
                    ])
              ]
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.activity,
                rules: _vm.rules,
                "label-width": "120px",
                "label-suffix": "："
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "拼单名称", prop: "name" } },
                [
                  _vm.isEnd
                    ? _c("span", [_vm._v(_vm._s(_vm.activity.name))])
                    : _c("el-input", {
                        attrs: {
                          type: "text",
                          maxlength: "20",
                          placeholder: "请输入拼单名称(20字以内)"
                        },
                        model: {
                          value: _vm.activity.name,
                          callback: function($$v) {
                            _vm.$set(_vm.activity, "name", $$v)
                          },
                          expression: "activity.name"
                        }
                      })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "活动时间",
                    required: "",
                    error: _vm.error.date
                  }
                },
                [
                  _vm.isEnd
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.activity.startTime) +
                            " ~ " +
                            _vm._s(_vm.activity.endTime)
                        )
                      ])
                    : [
                        _c("el-date-picker", {
                          attrs: {
                            disabled: _vm.isEdit,
                            type: "datetime",
                            placeholder: "开始时间",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "picker-options": _vm.pickerOptions
                          },
                          model: {
                            value: _vm.activity.startTime,
                            callback: function($$v) {
                              _vm.$set(_vm.activity, "startTime", $$v)
                            },
                            expression: "activity.startTime"
                          }
                        }),
                        _c("span", { staticClass: "pad5-lr" }, [_vm._v("~")]),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "结束时间",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "picker-options": _vm.pickerOptions
                          },
                          model: {
                            value: _vm.activity.endTime,
                            callback: function($$v) {
                              _vm.$set(_vm.activity, "endTime", $$v)
                            },
                            expression: "activity.endTime"
                          }
                        })
                      ]
                ],
                2
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发货地",
                    required: "",
                    error: _vm.error.addr
                  }
                },
                [
                  _vm.isEnd
                    ? _c("span", [_vm._v(_vm._s(_vm.activity.detailAddress))])
                    : _c("el-input", {
                        attrs: { placeholder: "请输入发货地址", type: "text" },
                        model: {
                          value: _vm.activity.detailAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.activity, "detailAddress", $$v)
                          },
                          expression: "activity.detailAddress"
                        }
                      })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "is-required",
                  attrs: { label: "活动类型", prop: "priceType" }
                },
                [
                  _vm.isEnd
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.activity.priceType === 1
                              ? "阶梯拼单"
                              : _vm.activity.priceType === 2
                              ? "秒杀拼单"
                              : "集采拼单"
                          )
                        )
                      ])
                    : _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isEdit },
                          on: { change: _vm.priceTypeChange },
                          model: {
                            value: _vm.activity.priceType,
                            callback: function($$v) {
                              _vm.$set(_vm.activity, "priceType", $$v)
                            },
                            expression: "activity.priceType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("阶梯拼单")
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("秒杀拼单")
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("集采拼单")
                          ])
                        ],
                        1
                      )
                ],
                1
              ),
              _vm.activity.priceType === 3
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "定金比例", prop: "depositRatio" } },
                      [
                        _c(
                          "div",
                          [
                            _c("span", [_vm._v("订单总金额的")]),
                            _vm.isEnd
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.activity.depositRatio))
                                ])
                              : _c("el-input", {
                                  staticClass: "w60 mar10-lr",
                                  attrs: {
                                    type: "text",
                                    maxlength: "2",
                                    oninput:
                                      "value=value.replace(/\\D|^0/g,'')",
                                    disabled: _vm.isEdit
                                  },
                                  model: {
                                    value: _vm.activity.depositRatio,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.activity,
                                        "depositRatio",
                                        $$v
                                      )
                                    },
                                    expression: "activity.depositRatio"
                                  }
                                }),
                            _c("span", [_vm._v("%")])
                          ],
                          1
                        ),
                        _c("div", { staticClass: "f12 gray9 lin-20" }, [
                          _vm._v("仅可填写大于等于1%，小于等于20%的整数")
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "拼单成功门槛", prop: "thresholdLimit" }
                      },
                      [
                        _vm.isEnd
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.activity.thresholdLimit === 0
                                    ? "无门槛"
                                    : "需达最低阶梯量"
                                )
                              )
                            ])
                          : _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.isEdit },
                                model: {
                                  value: _vm.activity.thresholdLimit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.activity,
                                      "thresholdLimit",
                                      $$v
                                    )
                                  },
                                  expression: "activity.thresholdLimit"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("无门槛")
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("需达最低阶梯量")
                                ])
                              ],
                              1
                            ),
                        _vm.activity.thresholdLimit === 1
                          ? _c("div", { staticClass: "f12 gray9 lin-20" }, [
                              _vm._v(
                                "仅支持添加单个商品，活动结束后，不达最低阶梯量，会自动退还定金"
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "货款支付", prop: "paymentTimeLimit" }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("span", [_vm._v("活动结束后")]),
                            _vm.isEnd
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.activity.paymentTimeLimit) +
                                      "小时"
                                  )
                                ])
                              : _c(
                                  "el-select",
                                  {
                                    staticClass: "w100 mar10-lr",
                                    attrs: { disabled: _vm.isEdit },
                                    model: {
                                      value: _vm.activity.paymentTimeLimit,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.activity,
                                          "paymentTimeLimit",
                                          $$v
                                        )
                                      },
                                      expression: "activity.paymentTimeLimit"
                                    }
                                  },
                                  _vm._l(_vm.paymentTimeList, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id
                                      }
                                    })
                                  }),
                                  1
                                ),
                            _c("span", [_vm._v("未支付，取消订单")])
                          ],
                          1
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { staticClass: "is-required", attrs: { label: "活动商品" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "group_btn b_red white f14 t_center mar20-b",
                          on: { click: _vm.selectGoodsList }
                        },
                        [_vm._v("点击添加商品")]
                      )
                    : _vm._e(),
                  _vm.checkGoodsList.length
                    ? _c(
                        "el-table",
                        {
                          staticClass: "check-table",
                          attrs: {
                            data: _vm.checkGoodsList,
                            "tooltip-effect": "dark"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "picUrl",
                              label: "商品图片",
                              width: "120"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("img", {
                                        staticClass: "goodImg",
                                        attrs: { src: scope.row.picUrl }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1764364089
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "商品名称",
                              "min-width": "20%"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "marketPriceStr",
                              label: "商品原价(￥)",
                              "min-width": "15%"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "unit",
                              label: "计量单位",
                              "min-width": "10%"
                            }
                          }),
                          _vm.activity.priceType !== 3
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "活动库存",
                                  "min-width": "15%"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm.isEnd
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.maxQuantity)
                                                )
                                              ])
                                            : _c("el-input", {
                                                attrs: {
                                                  oninput:
                                                    "value=value.replace(/\\D|^0/g,'')"
                                                },
                                                model: {
                                                  value: scope.row.maxQuantity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "maxQuantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.maxQuantity"
                                                }
                                              })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1975209208
                                )
                              })
                            : _vm._e(),
                          _vm.activity.priceType !== 2
                            ? [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "spec",
                                    label:
                                      _vm.activity.priceType === 1
                                        ? "阶梯量"
                                        : "总量",
                                    "min-width": "15%"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.goodsPriceList &&
                                            scope.row.goodsPriceList.length
                                              ? _vm._l(
                                                  scope.row.goodsPriceList,
                                                  function(item, index) {
                                                    return _c(
                                                      "div",
                                                      { key: item.level },
                                                      [
                                                        _c("span", [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mar5-r"
                                                            },
                                                            [_vm._v("≥")]
                                                          ),
                                                          _vm._v(
                                                            _vm._s(
                                                              item.minQuantity
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "span",
                                                  { staticClass: "gray9" },
                                                  [_vm._v("暂未设置")]
                                                )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2254700197
                                  )
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "spec",
                                    label: "价格(￥)",
                                    "min-width": "15%"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.goodsPriceList &&
                                            scope.row.goodsPriceList.length
                                              ? _vm._l(
                                                  scope.row.goodsPriceList,
                                                  function(item) {
                                                    return _c(
                                                      "div",
                                                      { key: item.level },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.price)
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "span",
                                                  { staticClass: "gray9" },
                                                  [_vm._v("暂未设置")]
                                                )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    4276595064
                                  )
                                })
                              ]
                            : [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "singlePrice",
                                    label: "拼单价(￥)",
                                    "min-width": "20%"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm.isEdit
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.singlePrice
                                                    )
                                                  )
                                                ])
                                              : _c("el-input", {
                                                  on: {
                                                    blur: function($event) {
                                                      scope.row.singlePrice = _vm.formatNums(
                                                        scope.row.singlePrice,
                                                        true
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.singlePrice,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "singlePrice",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.singlePrice"
                                                  }
                                                })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3743013690
                                  )
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "startQuantity",
                                    label: "起订量",
                                    "min-width": "15%"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm.isEdit
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.startQuantity
                                                    )
                                                  )
                                                ])
                                              : _c("el-input", {
                                                  attrs: {
                                                    oninput:
                                                      "value=value.replace(/\\D|^0/g,'')"
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.startQuantity,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "startQuantity",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.startQuantity"
                                                  }
                                                })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    273705419
                                  )
                                })
                              ],
                          _vm.activity.priceType === 3
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "startQuantity",
                                  label: "起订量",
                                  "min-width": "15%"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm.isEnd
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.startQuantity
                                                  )
                                                )
                                              ])
                                            : _c("el-input", {
                                                attrs: {
                                                  oninput:
                                                    "value=value.replace(/\\D|^0/g,'')"
                                                },
                                                model: {
                                                  value:
                                                    scope.row.startQuantity,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "startQuantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.startQuantity"
                                                }
                                              })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  361363256
                                )
                              })
                            : _vm._e(),
                          !_vm.isEdit
                            ? _c("el-table-column", {
                                attrs: { label: "操作", width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm.activity.priceType !== 2
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "info",
                                                    plain: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goodPriceSet(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("阶梯设置")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "info",
                                                plain: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeCheckGoods(
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("删除")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1419713245
                                )
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规则说明" } },
                [
                  _c("Tinymce", {
                    ref: "tinymce",
                    staticClass: "w840",
                    attrs: { id: "id", contentInit: _vm.contentInit }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _vm.isEnd
                  ? _c(
                      "div",
                      { staticClass: "t_center w840" },
                      [
                        _c("el-button", { on: { click: _vm.toList } }, [
                          _vm._v("返回")
                        ])
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "t_center w840" },
                      [
                        _c("el-button", { on: { click: _vm.toList } }, [
                          _vm._v("取消")
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("确认")]
                        )
                      ],
                      1
                    )
              ])
            ],
            2
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.chooseGoodVisible,
            "close-on-click-modal": false,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGoodVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "pad20_b" },
                [
                  _c("el-input", {
                    staticClass: "mar10-r",
                    attrs: { placeholder: "请输入商品名称" },
                    model: {
                      value: _vm.searchName,
                      callback: function($$v) {
                        _vm.searchName = $$v
                      },
                      expression: "searchName"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goodSearch }
                    },
                    [_vm._v("搜 索")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsDataList,
                    "row-key": "goodsId",
                    "max-height": "400"
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "55"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "picUrl", label: "商品图片", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("img", {
                              staticClass: "goodImg",
                              attrs: { src: scope.row.picUrl }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "商品名称" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "marketPriceStr",
                      width: "100",
                      label: "价格"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "currQuantity",
                      label: "库存数量",
                      width: "100"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.goodsDialogCancel } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "阶梯设置",
            visible: _vm.goodPriceVisible,
            "close-on-click-modal": false,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.goodPriceVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "pad20_b" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "mar10-r",
                      attrs: { type: "primary" },
                      on: { click: _vm.addGoodPrice }
                    },
                    [_vm._v("添加")]
                  ),
                  _c("i", { staticClass: "el-icon-question" }),
                  _c("span", { staticClass: "mar5-l" }, [
                    _vm._v("最多设置四级阶梯")
                  ])
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticClass: "goodPriceTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.goodsPriceList }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "level", label: "阶梯", width: "100" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "minQuantity",
                      label: _vm.activity.priceType === 1 ? "阶梯量" : "总量"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", { staticClass: "mar5-r" }, [
                              _vm._v("≥")
                            ]),
                            _c("el-input", {
                              attrs: {
                                oninput: "value=value.replace(/\\D|^0/g,'')"
                              },
                              model: {
                                value: scope.row.minQuantity,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "minQuantity", $$v)
                                },
                                expression: "scope.row.minQuantity"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "price", label: "价格(￥)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              on: {
                                blur: function($event) {
                                  scope.row.price = _vm.formatNums(
                                    scope.row.price,
                                    true
                                  )
                                }
                              },
                              model: {
                                value: scope.row.price,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "price", $$v)
                                },
                                expression: "scope.row.price"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.goodsPriceList.length > 2 &&
                            scope.row.level !== 1 &&
                            scope.row.level !== 2
                              ? _c("i", {
                                  staticClass: "el-icon-delete cursor",
                                  on: {
                                    click: function($event) {
                                      return _vm.delGoodPrice(scope.$index)
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.goodPriceVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsPriceConfirm }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }